export default "__VITE_ASSET__BHOoOtN$__"